<template>
  <div>
    <!-- 🔥 占位元素，防止吸顶时页面抖动 -->
    <div class="header-placeholder" :style="{ height: headerHeight + 'px' }" v-if="isFixed"></div>
    
    <header class="header-area" :class="{ 'header-fixed': isFixed }" ref="headerRef">
      <div class="header-centerbar">
        <div class="container">
          <div class="row align-items-center">
            <!-- 左侧 Logo -->
            <div class="col-lg-4 col-8">
              <div class="logo">
                <router-link to="/">
                  <img src="@/assets/images/logo.png" alt="Logo" />
                </router-link>
              </div>
            </div>
            <!-- 右侧导航区域 -->
            <div class="col-lg-8 col-4">
              <div class="header-right">
                <div class="header-nav-desktop">
                  <nav-items :darkClass="darkClass" />
                </div>
                <div class="header-nav-mobile" @click="hideSidebar">
                  <svg
                    class="menu-drawer"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="28"
                    fill="currentColor"
                    height="28"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M3 4h18v2H3V4zm6 7h12v2H9v-2zm-6 7h18v2H3v-2z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import NavItems from "../Common/NavItems.vue";

export default {
  components: { NavItems },
  props: {
    darkClass: {
      type: Object,
    },
  },
  data() {
    return {
      isFixed: false,
      headerHeight: 0,
    };
  },
  mounted() {
    this.headerHeight = this.$refs.headerRef?.offsetHeight || 80;
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateHeaderHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateHeaderHeight);
  },
  watch: {
    // 🔥 监听路由变化，确保菜单状态恢复
    '$route.path': {
      handler() {
        // 路由变化后重新检查滚动位置
        this.$nextTick(() => {
          this.handleScroll();
        });
      },
      immediate: true
    }
  },
  methods: {
    hideSidebar(e) {
      this.$emit("toggleSidebar", e);
    },
    handleScroll() {
      const threshold = 80;
      this.isFixed = window.scrollY > threshold;
    },
    updateHeaderHeight() {
      this.headerHeight = this.$refs.headerRef?.offsetHeight || 80;
    },
  },
};
</script>

<style scoped>
.header-area {
  background: #13358b;
  transition: all 0.3s ease;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
}

/* 🔥 吸顶样式 */
.header-area.header-fixed {
  position: fixed;
  background: rgba(19, 53, 139, 0.92);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.header-placeholder {
  display: block;
}

/* ===== 原有样式保持不变 ===== */
.header-centerbar {
  background: transparent;
  padding: 10px 0;
}

.logo img {
  max-height: 60px;
  width: auto;
  display: block;
}

.header-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
}

.header-nav-desktop {
  display: block;
}

.header-nav-mobile {
  display: none;
  cursor: pointer;
  color: #ffffff;
}
.header-nav-mobile:hover {
  color: #f0c040;
}

@media (max-width: 991px) {
  .header-nav-desktop {
    display: none;
  }
  .header-nav-mobile {
    display: block;
  }
  .logo img {
    max-height: 45px;
  }
  .header-centerbar {
    padding: 8px 0;
  }
}

@media (max-width: 576px) {
  .logo img {
    max-height: 35px;
  }
  .header-nav-mobile svg {
    width: 24px;
    height: 24px;
  }
}
</style>